import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    // 頁尾連結分類
    const footerLinks = [
        {
            title: '系統模組',
            links: [
                { text: '基礎出勤管理', path: '/features#attendance' },
                { text: '薪資與假勤管理', path: '/features#salary' },
                { text: '績效與考核管理', path: '/features#performance' },
                { text: '排班與工時管理', path: '/features#schedule' },
            ]
        },
        {
            title: '關於我們',
            links: [
                { text: '公司簡介', path: '/about' },
                { text: '最新消息', path: '/news' },
                { text: '常見問題', path: '/faq' },
                { text: '聯絡我們', path: '/contact' },
            ]
        },
        {
            title: '資源中心',
            links: [
                { text: '使用指南', path: '/guide' },
                { text: '部落格', path: '/blog' },
                { text: '客戶案例', path: '/case-studies' },
                { text: '影片教學', path: '/tutorials' },
            ]
        }
    ];

    return (
        <footer className="bg-gray-800 text-gray-300 pt-12 pb-6">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                    {/* 公司資訊區塊 */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center mb-4">
                            <Clock className="text-white" size={24} />
                            <span className="ml-2 text-lg font-bold text-white">智能出勤系統</span>
                        </div>
                        <p className="mb-4 text-gray-400 max-w-md">
                            整合出勤、薪資、績效、排班於一體的 SaaS 人事管理系統，提供企業完整的人力資源解決方案。
                        </p>
                        <div className="flex space-x-4 mb-6">
                            <a
                                href="https://facebook.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-400 hover:text-white transition-colors"
                                aria-label="Facebook"
                            >
                                FB
                            </a>
                            <a
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-400 hover:text-white transition-colors"
                                aria-label="Instagram"
                            >
                                IG
                            </a>
                            <a
                                href="https://line.me"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-400 hover:text-white transition-colors"
                                aria-label="Line"
                            >
                                LINE
                            </a>
                        </div>
                        <div className="space-y-2">
                            <p className="text-sm text-gray-400">
                                <span className="block">Email：pinter.huang@bancheng.com.tw</span>
                                <span className="block">電話：0988-261-474</span>
                                <span className="block">地址：新竹市東區中華路二段736號8樓之6</span>
                            </p>
                        </div>
                    </div>

                    {/* 連結區塊 */}
                    {footerLinks.map((category, index) => (
                        <div key={index}>
                            <h3 className="text-lg font-semibold mb-4 text-white">{category.title}</h3>
                            <ul className="space-y-2">
                                {category.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <Link
                                            to={link.path}
                                            className="text-gray-400 hover:text-white transition-colors"
                                        >
                                            {link.text}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* 版權信息 */}
                <div className="border-t border-gray-700 mt-8 pt-8 text-sm text-center text-gray-500">
                    <p>© {currentYear} 阪誠網通. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;